import { attributesToProps } from 'html-react-parser';
import { siteRenderers } from './siteNodeRenderers';

export function siteOptions(sourcePath, standalone = false) {
  const options = {
    replace(node) {
      if (!node.attribs) return;
      const context = { node, sourcePath, standalone, options };
      const renderer = siteRenderers.find(candidate => candidate.matches(context));
      if (!renderer) return;
      return renderer.render({ ...context, props: attributesToProps(node.attribs) });
    },
  };
  return options;
}